const toolbox = [
  // Backend
  { name: "PHP",icon:'<i class="devicon-php-plain"></i>', group: "Backend" },
  { name: "Symfony",icon:'<i class="devicon-symfony-original"></i>', group: "Backend" },
  { name: "Laravel",icon:'<i class="devicon-laravel-original"></i>', group: "Backend" },
  { name: "CakePHP",icon:'<i class="devicon-cakephp-plain"></i>', group: "Backend" },
  { name: "Livewire",icon:'<i class="devicon-livewire-plain"></i>', group: "Backend" },

  // Frontend
  { name: "React",icon:'<i class="devicon-react-original"></i>', group: "Frontend" },
  { name: "JavaScript",icon:'<i class="devicon-javascript-plain"></i>', group: "Frontend" },
  { name: "HTML",icon:'<i class="devicon-html5-plain"></i>', group: "Frontend" },
  { name: "CSS",icon:'<i class="devicon-css3-plain"></i>', group: "Frontend" },
  { name: "Tailwind CSS",icon:'<i class="devicon-tailwindcss-plain"></i>', group: "Frontend" },

  // Data
  { name: "MySQL",icon:'<i class="devicon-mysql-plain"></i>', group: "Data" },
  { name: "MariaDB",icon:'<i class="devicon-mariadb-plain"></i>', group: "Data" },
  { name: "Oracle",icon:'<i class="devicon-oracle-plain"></i>', group: "Data" },

  // DevOps / Workflow
  { name: "Docker",icon:'<i class="devicon-docker-plain"></i>', group: "DevOps / Workflow" },
  { name: "Linux",icon:'<i class="devicon-linux-plain"></i>', group: "DevOps / Workflow" },
  { name: "SSH",icon:'<i class="devicon-ssh-plain"></i>', group: "DevOps / Workflow" },
  { name: "Nginx",icon:'<i class="devicon-nginx-plain"></i>', group: "DevOps / Workflow" },
  { name: "Apache",icon:'<i class="devicon-apache-plain"></i>', group: "DevOps / Workflow" },
  { name: "Git",icon:'<i class="devicon-git-plain"></i>', group: "DevOps / Workflow" },
  { name: "GitHub",icon:'<i class="devicon-github-original"></i>', group: "DevOps / Workflow" },
  { name: "GitLab",icon:'<i class="devicon-gitlab-plain"></i>', group: "DevOps / Workflow" },
  { name: "Jira",icon:'<i class="devicon-jira-plain"></i>', group: "DevOps / Workflow" },
  { name: "ServiceNow",icon:'<i class="devicon-servicenow-plain"></i>', group: "DevOps / Workflow" },
  { name: "Trello",icon:'<i class="devicon-trello-plain"></i>', group: "DevOps / Workflow" },
];

export default toolbox;
